// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5637fd54","455":"88f095a4","971":"7d50ce3f","977":"1eaba511"}[chunkId] + ".chunk.js";
};